import React from 'react';

import {PopoverBody} from 'reactstrap';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {
  AttachOverlay,
  AttachOverlayChildProps,
  OverlayPlacementType,
  OverlayProps,
  PopoverForm,
} from 'app/general/overlays';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

interface ConfirmSharedProps {
  text?: React.ReactNode;
  isIdle?: boolean;
  confirmText?: string;
  busyText?: string;
  onConfirm: () => any;
}

interface ConfirmFormProps extends ConfirmSharedProps {
  overlayProps: OverlayProps;
}

export const ConfirmFormPopover = ({
  isIdle,
  onConfirm,
  busyText,
  confirmText,
  text,
  overlayProps,
}: ConfirmFormProps) => (
  <PopoverForm overlayProps={overlayProps}>
    {({close, closeOnSuccess}) => (
      <>
        <PopoverBody>{text}</PopoverBody>
        <StyledPopoverBottomDIV>
          <button
            onClick={close}
            disabled={isIdle === false}
            className="btn btn-sm btn-light mr-2"
          >
            {gt('Cancel')}
          </button>
          <StateButton
            isIdle={isIdle}
            onClick={() => closeOnSuccess(onConfirm())}
            className="btn-sm btn-danger"
            busyText={busyText}
          >
            {confirmText}
          </StateButton>
        </StyledPopoverBottomDIV>
      </>
    )}
  </PopoverForm>
);

interface ConfirmPopoverProps extends ConfirmSharedProps {
  placement: OverlayPlacementType;
  children: (props: AttachOverlayChildProps) => React.ReactElement;
}
export const ConfirmPopover = ({
  placement,
  children,
  text,
  ...other
}: ConfirmPopoverProps) => (
  <AttachOverlay
    trigger="click"
    overlay={({overlayProps}) => (
      <ConfirmFormPopover
        overlayProps={{...overlayProps, placement}}
        text={text !== undefined ? text : gt('Are you sure?')}
        {...other}
      />
    )}
  >
    {children}
  </AttachOverlay>
);
